import { Component } from '@angular/core';
import { Logger } from '@shared/common/logger';
import { DiscountService } from 'src/app/services/discount.service';
import { MediaService } from '@studiobuki/web-core/lib/media';
import { faqDataCondensed } from 'src/app/data/faq/data';
import { Router } from '@angular/router';
import { ROUTE_PATH_FAQ } from '@studiobuki/web-core/lib/routing';
import Books from 'src/app/data/books';
import { stepsData } from 'src/app/data/steps/data';
import AlphabetTrain from 'src/app//data/books/AlphabetTrain';
import Froebelkan from 'src/app/data/books/Froebelkan';
import { reviewsData } from 'src/app/data/reviews/reviews';
import { descriptionData } from 'src/app/data/description/description';
import { BookAlphabetTrainService } from '../book-page/pages/book-alphabet-train/book-alphabet-train.service';

const log = new Logger('HomePageComponent');

@Component({
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent {
  public readonly books = Books;

  public readonly book = AlphabetTrain;

  public readonly faqDataCondensed = faqDataCondensed;

  public readonly sectionSteps = stepsData;

  public readonly reviewsData = reviewsData;

  public readonly descriptionData = descriptionData;

  public readonly Froebelkan = Froebelkan;

  public loading = false;

  constructor(
    public discountService: DiscountService,
    public mediaService: MediaService,
    private _bookFroebelkanService: BookAlphabetTrainService,
    private _router: Router,
  ) {}

  public onFaqButtonClick() {
    log.info('onFaqButtonClick');
    return this._router.navigate([ROUTE_PATH_FAQ]);
  }
}
